// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ButtonsPage-margins__d88f1b9a5fff2df5a182{margin-top:8px;margin-bottom:8px;position:relative}.ButtonsPage-margins__d88f1b9a5fff2df5a182 img{position:absolute;left:24px;bottom:20px;height:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"margins": "ButtonsPage-margins__d88f1b9a5fff2df5a182"
};
export default ___CSS_LOADER_EXPORT___;
